import { getRouteRussiaLanding } from 'shared/consts';
import { AuthFlow } from 'shared/lib/authFlow';

export const shouldOpenRussiaOnboarding = (
  ingressPath: string | null,
  authFlow: AuthFlow | null,
  setupUrl?: string
) =>
  ingressPath === getRouteRussiaLanding() &&
  authFlow === 'sign_up' &&
  Boolean(setupUrl);
